module.exports = __webpack_public_path__ + "images/statistics@1x.png?7f9a0564";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/statistics@1x.png
// module id = 707
// module chunks = 7